<template>
  <v-sheet class="py-6 px-8">
    <p class="text-h6 font-weight-bold grey--text text--darken-3 text-center mb-6">트래블러 추가하기</p>

    <v-sheet class="mt-2 px-4">
      <v-text-field class="rounded-10" label="이름" dense outlined v-model.trim="create.name"></v-text-field>
      <v-text-field class="rounded-10" label="코드" dense outlined v-model.trim="create.code"></v-text-field>
      
      <!-- 새로운 트래블러 관련 필드들 -->
      <v-text-field 
        class="rounded-10" 
        label="인센티브 (%)" 
        dense 
        outlined 
        type="number" 
        v-model.number="create.incentive_percent"
        hint="숫자만 입력하세요 (예: 10)"
      ></v-text-field>
      <v-text-field 
        class="rounded-10" 
        label="이메일" 
        dense 
        outlined 
        type="email" 
        v-model.trim="create.email"
      ></v-text-field>
      <v-text-field 
        class="rounded-10" 
        label="전화번호" 
        dense 
        outlined 
        v-model.trim="create.phone"
      ></v-text-field>
      <v-text-field 
        class="rounded-10" 
        label="은행명" 
        dense 
        outlined 
        v-model.trim="create.bank"
      ></v-text-field>
      <v-text-field 
        class="rounded-10" 
        label="계좌번호" 
        dense 
        outlined 
        v-model.trim="create.account_number"
      ></v-text-field>
      
      <v-row>
        <v-menu v-model="startAtMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="create.startAtDate" label="예약 시작일자" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" color="green"></v-text-field>
          </template>
          <v-date-picker v-model="create.startAtDate" no-title scrollable color="green" @input="startAtMenu = false"></v-date-picker>
        </v-menu>
        <v-menu v-model="endAtMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="create.endAtDate" label="예약 종료일자" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" color="warning"></v-text-field>
          </template>
          <v-date-picker v-model="create.endAtDate" no-title scrollable color="warning" @input="endAtMenu = false"> </v-date-picker>
        </v-menu>
      </v-row>
    </v-sheet>
    <v-sheet class="d-flex justify-center mt-5">
      <v-btn class="rounded-10 px-6 mr-4" color="grey" large dark depressed @click="$emit('close')">
        <v-icon small left>mdi-cancel</v-icon>
        취소하기
      </v-btn>
      <v-btn class="rounded-10 px-6" color="primary" large dark depressed @click="createSubmit()">
        <v-icon small left>mdi-database-plus-outline</v-icon>
        추가하기
      </v-btn>
    </v-sheet>
  </v-sheet>
</template>
<script>
import TipTapWriter from "@/components/tiptap/Writer"

export default {
  components: {
    TipTapWriter,
  },
  data: () => ({
    yesOrNo: ["Y", "N"],
    create: {
      name: "",
      code: "",
      clothPrice: 0,
      clothPriceUSD: 0,
      clothPriceWeekend: 0,
      clothPriceWeekendUSD: 0,
      tenOverTimePrice: 0,
      tenOverTimePriceUSD: 0,
      changeDressPrice: 0,
      changeDressPriceUSD: 0,
      isEnable: true,
      startAtDate: null,
      endAtDate: null,
      isTraveler: "Y",
      // 새로운 트래블러 관련 필드들
      incentive_percent: null,
      email: "",
      phone: "",
      bank: "",
      account_number: "",
    },
    startAtMenu: false,
    endAtMenu: false,

    //TipTap
    options: {
      content: "",
      editable: true,
      supportImage: true,
      supportVideo: true,
    },
    componentKey: 0,

    //TipTap
    desc2Options: {
      content: "",
      editable: true,
      supportImage: true,
      supportVideo: true,
    },
    desc2ComponentKey: 0,
  }),

  mounted() {
    this.$http.get("/api/promotion/select").then((res) => {
      const defaultPrice = res.data.find((e) => e.code == "default")
      if (defaultPrice) {
        this.create.clothPrice = defaultPrice.clothPrice
        this.create.clothPriceUSD = defaultPrice.clothPriceUSD
        this.create.clothPriceWeekend = defaultPrice.clothPriceWeekend
        this.create.clothPriceWeekendUSD = defaultPrice.clothPriceWeekendUSD
        this.create.tenOverTimePrice = defaultPrice.tenOverTimePrice
        this.create.tenOverTimePriceUSD = defaultPrice.tenOverTimePriceUSD
        this.create.changeDressPrice = defaultPrice.changeDressPrice
        this.create.changeDressPriceUSD = defaultPrice.changeDressPriceUSD
      }
    })
  },

  methods: {
    clear() {
      this.options.content = ""
      this.componentKey++
    },
    clearDesc2() {
      this.desc2Options.content = ""
      this.desc2ComponentKey++
    },

    // 목록
    createSubmit: _.debounce(async function () {
      // 제목 검증
      // if (this.create.name == "") {
      //   alert("이름을 입력해주세요")
      //   return
      // }

      // 컨셉소개 내용 검증
      if (this.create.code == "") {
        alert("프로모션 코드를 입력해주세요")
        return
      }

      if (!this.create.endAtDate) {
        alert("종료일자를 입력해주세요")
        return
      }
      console.log(this.create.startAtDate)
      console.log(this.create.endAtDate)

      this.$http
        .post("/api/promotion/insert", {
          params: {
            code: this.create.code,
            name: this.create.name,
            clothPrice: Number(this.create.clothPrice),
            clothPriceUSD: Number(this.create.clothPriceUSD),
            clothPriceWeekend: Number(this.create.clothPriceWeekend),
            clothPriceWeekendUSD: Number(this.create.clothPriceWeekendUSD),
            tenOverTimePrice: Number(this.create.tenOverTimePrice),
            tenOverTimePriceUSD: Number(this.create.tenOverTimePriceUSD),
            changeDressPrice: Number(this.create.changeDressPrice),
            changeDressPriceUSD: Number(this.create.changeDressPriceUSD),
            role: this.create.isTraveler === "Y" ? "TRAVELER" : null,
            enabled: this.create.isEnable,
            startAt: this.create.startAtDate ? this.dayjs(this.create.startAtDate).format("YYYY-MM-DD HH:mm:ss") : null,
            endAt: this.create.endAtDate ? this.dayjs(this.create.endAtDate).format("YYYY-MM-DD HH:mm:ss") : null,
            description: this.options.content ? this.options.content : null,
            description2: this.desc2Options.content ? this.desc2Options.content : null,
            // 새로운 트래블러 관련 필드들 추가
            incentive_percent: this.create.incentive_percent,
            email: this.create.email || null,
            phone: this.create.phone || null,
            bank: this.create.bank || null,
            account_number: this.create.account_number || null,
          },
        })
        .then((res) => {
          if (res) {
            alert("정상적으로 등록되었습니다.")
            this.$emit("close")
          } else {
            alert("등록되지 않았습니다")
          }
        })
        .catch((e) => {
          console.log(e)
          alert(this.$t("alert.error_page"))
        })
    }, 500),
  },
}
</script>
<style scoped>
.my-clipper {
  width: 100%;
}

.placeholder {
  width: 100%;
  height: 150px;
}
</style>
